import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import SubmodClassForm from '../components/forms/SubmodClassForm';
import '../styles/EmployeeMaster.css';
import SubmodClassTable from '../components/SubmodClassTable';
 
const SubmodClassEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route
 
  const [submodClassData, setSubmodClassData] = useState(null);
  const [loading, setLoading] = useState(false);
 
  // ✅ Show modal only if URL starts with /SubmodClass/edit
  const showModal = location.pathname.startsWith('/submodClass/edit');
 
  const handleCloseModal = () => {
    navigate('/submodClass'); // Go back to list
  };
 
  // ✅ Fetch SubmodClass details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getSubmodClassById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setSubmodClassData(data.data);
          } else {
            setSubmodClassData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching SubmodClass by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);
 
  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>SubmodClass Master</h2>
      </div>
 
      {/* Table of SubmodClasss */}
      <SubmodClassTable />
 
      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit SubmodClass</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : submodClassData ? (
            <SubmodClassForm submodClassId={id} initialData={submodClassData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this SubmodClass.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
 
export default SubmodClassEditModel;